import * as AampAdapter from './aamp-config-adapter';
import * as ShakaAdapter from './shaka-config-adapter';
import * as AndroidTvAdapter from './android-tv-config-adapter';
export function adaptSdkPlayersClientConfig() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, device = arguments.length > 1 ? arguments[1] : void 0;
    var _config_clientConfig = config.clientConfig, clientConfig = _config_clientConfig === void 0 ? {} : _config_clientConfig, _config_defaultConfig = config.defaultConfig, defaultConfig = _config_defaultConfig === void 0 ? {} : _config_defaultConfig;
    return {
        androidTv: AndroidTvAdapter.adaptAndroidTvClientConfig({
            defaultConfig: defaultConfig.androidTv,
            clientConfig: clientConfig.androidTv
        }),
        tizen: clientConfig.tizen,
        webMaf: clientConfig.webMaf,
        webOS: clientConfig.webOS,
        shaka: ShakaAdapter.adaptShakaClientConfig({
            defaultConfig: defaultConfig.shaka,
            clientConfig: clientConfig.shaka
        }, device),
        aamp: AampAdapter.adaptAampClientConfig(clientConfig.aamp),
        theo: clientConfig.theo,
        tape: clientConfig.tape
    };
}
export function adaptSdkPlayersRemoteConfigSplit(config, device) {
    var _config_clientConfig = config.clientConfig, clientConfig = _config_clientConfig === void 0 ? {} : _config_clientConfig, _config_remoteConfig = config.remoteConfig, remoteConfig = _config_remoteConfig === void 0 ? {} : _config_remoteConfig;
    return {
        aamp: AampAdapter.adaptAampRemoteConfigSplit({
            remoteConfig: remoteConfig.aamp,
            clientConfig: clientConfig.aamp
        }),
        shaka: ShakaAdapter.adaptShakaRemoteConfigSplit({
            remoteConfig: remoteConfig.shaka,
            clientConfig: clientConfig.shaka
        }, device),
        androidTv: AndroidTvAdapter.adaptAndroidTvRemoteConfigSplit({
            remoteConfig: remoteConfig.androidTv,
            clientConfig: clientConfig.androidTv
        }),
        tizen: clientConfig.tizen,
        webMaf: clientConfig.webMaf,
        webOS: clientConfig.webOS,
        theo: clientConfig.theo,
        tape: clientConfig.tape
    };
}

//# sourceMappingURL=players-config-adapter.js.map